

import Vue from 'vue'
import store from './vuex'
import FastClick from 'fastclick'
import router from './router/index'
import App from './App'
import VeeValidate, {Validator}  from 'vee-validate'

import zh_CN from 'vee-validate/dist/locale/zh_CN';
import configer from '@/assets/js/validates'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import ConfigPlugin from 'vux/src/plugins/config/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import validators from '@/assets/js/validitors'

Object.assign(configer,{
locale: 'zh_CN',
dictionary: {
zh_CN
}
})



Vue.use(LoadingPlugin);
Vue.use(VeeValidate, configer);
Vue.use(AjaxPlugin);
Vue.use(ToastPlugin);
Vue.component('popup-picker', PopupPicker)
Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX'
})

FastClick.attach(document.body);

Vue.config.productionTip = false;


new Vue({
router,
validators,
store,
render: h => h(App)
}).$mount('#app-box');




// WEBPACK FOOTER //
// ./src/main.js